// extracted by mini-css-extract-plugin
export default {"countdown":"x_-z","srOnly":"y_-z"};